﻿<script lang="ts" setup>
import {
  useDashboardStore,
  useSessionStore
} from 'src/store';
import {useRouter} from 'vue-router';
import {useI18n} from 'vue-i18n';
import {
  onMounted,
  ref
} from 'vue';

const dashboardStore = useDashboardStore(),
  router = useRouter(),
  sessionStore = useSessionStore(),
  {t} = useI18n();

const skipForNowDialog = ref(false)

function onOkayClicked() {
  router.push({ name: 'CommunicationPreferences', params: { interrupt: 'true' } });
}

function skipForNowClick () {
  dashboardStore.setSkipCommunicationPreferencesInterrupt(true);

  skipForNowDialog.value = false;
  
  router.push({ name: 'Interrupts', params: { reload: 'false' } });
}

onMounted(() => {
  document.querySelectorAll('html')[0].scrollTop = 0;

  sessionStore.setIsHeaderVisible(true);
});
</script>

<template>
  <q-page class="text-center" padding>
    <zbm-box :box-bkgd-color="$zb.enums.BoxBackgroundColorEnum.linearGradient"
             :box-padding="$zb.enums.BoxPaddingEnum.p303040">

      <!-- Heading -->
      <div class="row items-center heading">
        
        <!-- Skip -->
        <div class="col-auto">
          
          <!-- Button -->
          <zbm-btn-icon @click="skipForNowDialog = true"
                        data-testid="skipButton"
                        icon="fa-regular fa-xmark"
                        size="24px"
                        text-color="content-grd-bg-content" />

          <!-- Dialog -->
          <zbm-dialog v-model="skipForNowDialog">

            <!-- Header -->
            <div class="row q-dialog__header">
              <div class="col-auto">
                <h3>{{ t('skip_for_now') }}</h3>
              </div>
            </div>

            <!-- Body -->
            <div class="row q-dialog__body">
              <div class="col">
                <p v-html="t('update_communication_status')" />
              </div>
            </div>

            <!-- Footer (CTA button(s)) -->
            <div class="row q-dialog__footer">

              <!-- Okay Button -->
              <div class="col-auto">
                <zbm-btn @click="skipForNowClick"
                         :color="$zb.enums.ButtonStdColorEnum.accent"
                         data-testid="skipOkayButton"
                         :height="$zb.enums.ButtonHeightEnum.lg"
                         :label="t('gen_okay')" />
              </div>

              <!-- Go Back Button -->
              <div class="col-auto">
                <zbm-btn v-close-popup
                         :color="$zb.enums.ButtonStdColorEnum.accentText"
                         data-testid="skipGoBackButton"
                         :height="$zb.enums.ButtonHeightEnum.lg"
                         :label="t('go_back')" />
              </div>
            </div>
          </zbm-dialog>
        </div>

        <!-- Title -->
        <div class="col">
          <h2 class="text-weight-regular">{{ t('communication') }}</h2>
        </div>

        <!-- Offset Cancel -->
        <div class="col-auto" />
      </div>

      <!-- Comments Icon -->
      <q-icon class="mb-30"
              color="white"
              name="fa-solid fa-comments"
              size="120px" />

      <!-- Content -->
      <h3 class="mb-30">{{ t('communication') }}</h3>
      <p>{{ t('communication_description') }}</p>

      <!-- Okay Button -->
      <zbm-btn @click="onOkayClicked"
               class="glow--white"
               :color="$zb.enums.ButtonStdColorEnum.darkTeal"
               data-testid="okayButton"
               :height="$zb.enums.ButtonHeightEnum.lg"
               :label="t('gen_okay')"
               :width="$zb.enums.ButtonWidthEnum.wFull" />
    </zbm-box>
  </q-page>
</template>

<style lang="scss" scoped>
@use 'sass:map';

.box {
  width: 100%;
  max-width: 375px;
  margin-inline: auto;

  h2,
  h3,
  p {
    color: map.get($co-brand-clrs, content-grd-bg-content);
  }

  p {
    font-size: 18px;
    margin-block-end: 190px;
  }
  
  // Heading
  .heading { // .row
    $heading-gutter: 30px;
    
    margin-inline: -$heading-gutter;
    margin-block-end: 32px;
    
    .col-auto {
      width: $heading-gutter;
      max-width: $heading-gutter;
      flex-basis: $heading-gutter;
      
      &:first-child {
        text-align: end;
      }
    }
    
    .col {
      padding-inline: $bs-grid-gutter-md;
    }
  }
}
</style>